((MegaCollection, $) => {
  'use strict';

  let $navSlider;

  const cacheDom = () => {
    $navSlider = $('[super-collection-nav-slider]');
  };

  const initNavSlider = () => {
    console.log('Slider initializing...')
    $navSlider.slick({
      slidesToShow: 5,
      autoplay: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            autoplay: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            autoplay: true
          }
        }
      ]
    });
  };

  const bindUIActions = () => {
    
  };

  const init = () => {
    cacheDom();
    initNavSlider();
    // bindUIActions();
  };

  MegaCollection.init = init;
})(window.MegaCollection = window.MegaCollection || {}, jQuery);
